import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-validate-success',
  templateUrl: './validate-success.component.html',
  styleUrls: ['./validate-success.component.scss']
})
export class ValidateSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
